export default __webpack_public_path__ + "static/all-fcd7659fb1cb944167c8d937a48119dc.png";